var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "event-flow-grid",
    style: {
      'grid-template-rows': "repeat(".concat(_vm.length, ", ").concat(_vm.rowHeight, "px)")
    },
    attrs: {
      "id": "event-flow-grid"
    }
  }, [_vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }